import { ILegendItem } from './ILegendItem.interface';
import { Typography } from '@material-ui/core';
import { useStyles } from './legend.style';

interface LegendProps {
  className?: string;
  legendItems: ILegendItem[];
}

function Legend({ className, legendItems }: Readonly<LegendProps>) {
  const { cx, classes } = useStyles();

  return (
    <aside className={cx(classes.legend, className)}>
      {legendItems.map(item => (
        <div key={item.label} className={classes.legendItem}>
          <div style={{ background: item.color }} />
          <Typography variant="body2">{item.label}</Typography>
        </div>
      ))}
    </aside>
  );
}

export { Legend };
